import { getAuthUserProfile, OpenAPI } from '@api/admin'
import {
  derivePermissionsFromToken,
  handleCatchError,
  INACTIVE_ROLE
} from '@common/utils'
import { useCallback, useEffect } from 'react'
import { useAuth } from 'react-oidc-context'

import { useAuthStore } from '@/stores/authStore'
import { usePermissionsStore } from '@/stores/permissionsStore'

export const PermissionsBridge = () => {
  const { logoutUser } = useAuthStore()
  const { isAuthenticated, user } = useAuth()
  const setPermissions = usePermissionsStore(s => s.setPermissions)

  const profile = getAuthUserProfile()
  const userRole = profile?.MolsonPrice ?? ''

  // Synchronously set token during render to prevent race conditions
  // where child components fire API calls before the useEffect has run
  if (user?.access_token) {
    OpenAPI.TOKEN = user.access_token
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: userRole and user are the real deps
  const loadPermissions = useCallback(
    (authenticated: boolean) => {
      if (!authenticated) {
        return
      }

      if (userRole.toLowerCase() === INACTIVE_ROLE) {
        logoutUser()
        return
      }

      if (!user?.access_token) {
        return
      }

      try {
        setPermissions(derivePermissionsFromToken(user.access_token))
      } catch (e) {
        setPermissions([])
        handleCatchError(e)
      }
    },
    [userRole, user]
  )

  useEffect(() => {
    loadPermissions(isAuthenticated)
  }, [loadPermissions, isAuthenticated])

  return null
}
